'use client';

import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { getArticleDetailBySlug } from '@/services/publicService';

const RESOURCE_ARTICLES = [
  {
    title: 'Natural Gas ETFs: How They Work and How to Build a Portfolio',
    slug: 'natural-gas-etfs-how-they-work-and-how-to-build-a-portfolio-6a09ff79cd7ef',
    description: 'Learn how natural gas ETFs work and how they can fit into a diversified energy portfolio.',
  },
  {
    title: 'Best Natural Gas ETFs to Buy in 2026',
    slug: 'best-natural-gas-etfs-to-buy-in-2026-6a05f6c6754c6',
    description: 'Discover top natural gas ETF options for investors looking for energy exposure in 2026.',
  },
  {
    title: 'What Are Oil and Gas Stocks? A Beginner’s Guide',
    slug: 'what-are-oil-and-gas-stocks-a-beginners-guide-693a6c67bd85a',
    description: 'Understand the basics of oil and gas stocks and how they can be used in an investment strategy.',
  },
];

const truncateWords = (text, limit = 25) => {
  const words = String(text || '').trim().split(/\s+/).filter(Boolean);
  return words.length > limit ? `${words.slice(0, limit).join(' ')}...` : words.join(' ');
};

const ResourseLearning = () => {
  const [articles, setArticles] = useState(RESOURCE_ARTICLES);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const nextArticles = await Promise.all(
          RESOURCE_ARTICLES.map(async (article) => {
            const resp = await getArticleDetailBySlug(article.slug);
            const data = resp?.data || {};
            const takeaways = data.takeaways;
            const takeawaysText = Array.isArray(takeaways) ? takeaways.join(' ') : takeaways || '';
            return {
              ...article,
              title: data.title || article.title,
              description: truncateWords(takeawaysText || data.excerpt || data.description || article.description),
            };
          })
        );
        if (!cancelled) setArticles(nextArticles);
      } catch (error) {
        if (!cancelled) setArticles(RESOURCE_ARTICLES);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section className="resources-section">
        <div className="container">
          <h2 className="section-title text-center">Explore Our Learning Resources</h2>
          <p className="section-subtitle text-center">
            Dive into learning and build your portfolio with our curated resources to make your journey easier: assess the market, access opportunities, and align your goals.
          </p>
          
          <div className="row mt-5 resource-card-row">
            {articles.map((article, index) => (
              <div key={index} className="col-lg-4 col-md-6 mb-4">
                <div className="resource-card-wrapper">
                  <div className="resource-card">
                    <h3 className="resource-title">{article.title}</h3>
                    <p className="resource-description">
                      {article.description}
                    </p>
                    <Link href={article.slug ? `/article/${article.slug}` : '#'} className="resource-link">
                      Read More
                      <svg width="29" height="24" viewBox="0 0 29 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0_3491_1545)">
                          <path d="M15.695 16.83L20.5 12L15.695 7.16998C15.6516 7.11299 15.5965 7.066 15.5333 7.03217C15.4702 6.99834 15.4005 6.97848 15.329 6.97392C15.2576 6.96935 15.1859 6.98021 15.119 7.00573C15.0521 7.03126 14.9914 7.07087 14.9411 7.12188C14.8909 7.17289 14.8521 7.23411 14.8275 7.30139C14.803 7.36867 14.7931 7.44045 14.7987 7.51186C14.8043 7.58327 14.8252 7.65265 14.8599 7.7153C14.8946 7.77795 14.9424 7.8324 15 7.87498L18.595 11.5L9.03 11.5C8.89739 11.5 8.77022 11.5527 8.67645 11.6464C8.58268 11.7402 8.53 11.8674 8.53 12C8.53 12.1326 8.58268 12.2598 8.67645 12.3535C8.77022 12.4473 8.89739 12.5 9.03 12.5L18.595 12.5L15 16.125C14.9065 16.2191 14.8543 16.3466 14.8547 16.4792C14.8552 16.6119 14.9083 16.739 15.0025 16.8325C15.0967 16.926 15.2241 16.9782 15.3568 16.9778C15.4894 16.9773 15.6165 16.9241 15.71 16.83H15.695Z" fill="#0C0C0C"/>
                          </g>
                          <rect x="26" y="2.5" width="19" height="23" rx="9.5" transform="rotate(90 26 2.5)" stroke="#0C0C0C"/>
                          <defs>
                          <clipPath id="clip0_3491_1545">
                          <rect x="25.5" y="3" width="18" height="22" rx="9" transform="rotate(90 25.5 3)" fill="white"/>
                          </clipPath>
                          </defs>
                        </svg>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-5">
            <Link href={'/resources'} className="btn btn-primary" style={{ textDecoration: 'none', cursor: 'pointer' }}>Explore Our Resources</Link>
          </div>
        </div>
      </section>
  );
};

export default ResourseLearning;
